import {ReviewModalWindow} from './ReviewModalWindow';
export default ReviewModalWindow;
